import styled, { css } from "styled-components";
import { Paragraph, Heading } from "../../../atoms/Typography/Typography.styles";

interface HeroNewsProps {
  colorBrand?: string;
  colorScheme?: string;
  withBackground?: boolean;
}

const getColorFromBrand = (brand: string) => {
  const brandColorMap = {
    'warmGrey': 'black',
    'lightGrey': 'black',
    'oliveGreen': 'black',
    'neutralTeal': 'black',
    'warmYellow': 'black',
    'neutralBlack': 'white',
    'warmClay': 'white',
    'warmOrange': 'white',
    'darkGreen': 'white',
    'nightSky': 'white',
  }

  return brandColorMap[brand] || 'white'
}

const tagColors = {
  warmGrey: "#CFC6BE",
  lightGrey: "#F8FAF2",
  neutralBlack: "#4B4846",
  warmClay: "#A07D6A",
  neutralTeal: "#B1DEE6",
  warmOrange: "#E5673E",
  oliveGreen: "#B6CFBF",
  darkGreen: "#3F605E",
  warmYellow: "#FCC06D",
  nightSky: "#3B7693",
}

export const HeroNews = styled.div<HeroNewsProps>`
  padding: ${({ theme }) => theme.rem(48)};

  ${({ theme }) => theme.mediaQuery.xl(`
    padding: ${theme.rem(42, 0, 84)};
  `)}

  ${Paragraph},
  ${Heading} {
    color: ${({ theme, colorScheme, withBackground }) => withBackground ? theme.colorScheme[`${colorScheme}`].surface.text.base.negative : 'black'};
  }
`

export const HeroNewsInner = styled.div<HeroNewsProps>`
  border-top: 1px solid ${({ theme, withBackground, colorScheme }) => withBackground ? theme.colorScheme[`${colorScheme}`].surface.text.base.negative : 'black'};
  padding-top: ${({ theme }) => theme.rem(32)};

  ${({ theme }) => theme.mediaQuery.xl(`
    padding-top: ${theme.rem(84)};
  `)}
`

export const HeroNewsInfo = styled.div`
  display: flex;
  align-items: center;
  margin-top: ${({ theme }) => theme.rem(32)};

  ${({ theme }) => theme.mediaQuery.xl(`
    margin-top: 0;
  `)}
`;

export const HeroDate = styled.div`
  text-transform: capitalize;
`;

export const HeroCategories = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.rem(8)};
  position: relative;
  padding: ${({ theme }) => theme.rem(0, 16)};
  margin-left: ${({ theme }) => theme.rem(16)};

  &:before {
    content: '';
    width: 1px;
    height: 110%;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    position: absolute;
    background-color: black;
  }
`;

export const HeroCategory = styled.div<HeroNewsProps>`
  padding: ${({ theme }) => theme.rem(8, 16)};
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: ${({ theme }) => theme.rem(52)};

  ${({ color }) => color && css`
    background-color: ${tagColors[`${color}`] };
    
    > * {
      color: ${getColorFromBrand(color)}!important;
    }
  `}

`;

interface MaskWrapperProps {
  maskType?: 'circle' | 'leaf' | 'ellipse'
}

export const MaskWrapper = styled.div<MaskWrapperProps>`
  width: 100%;
  position: relative;
  height: ${({ maskType, theme }) => maskType === 'circle' ? '100%' : theme.rem(250)};
  max-height: ${({ theme }) => theme.rem(500)};
  margin: 0 auto;
  aspect-ratio: 4 / 4;
  overflow: hidden;

  ${({ maskType }) => maskType && css`
    mask-image: url('/masks/mask-${maskType}.svg');
    mask-size: 100%;
    mask-repeat: no-repeat;
    mask-position: center;
  `}
  
  ${({ theme, maskType }) => theme.mediaQuery.md(`
    max-width: 100%;
    width: ${maskType === 'circle' ? 'auto' : '80%'};
    height: ${maskType === 'circle' ? theme.rem(500) : theme.rem(360)};
  `)};

  ${({ theme, maskType }) => theme.mediaQuery.xl(`
    height: ${maskType === 'circle' ? theme.rem(540) : theme.rem(360)};
  `)};

  img {
    object-fit: cover;
    object-position: center;
  }
`